// extracted by mini-css-extract-plugin
export default {"cls1":"NBUk7TKJtjJvq66eVmJ9","cls2":"dCTNNWNd_6Sjn43z4BkD NBUk7TKJtjJvq66eVmJ9"};